import React from 'react';
import clsx from 'clsx';

import { TitleTag } from '../..';

type Props = {
  id?: string;
  className?: string;
  tag?: TitleTag;
  size?: keyof typeof Size;
  children: React.ReactNode;
};

export enum Size {
  xlarge = 'text-xlarge',
  large = 'text-large',
  medium = 'text-medium',
  small = 'text-small',
}

export const Title = React.forwardRef<HTMLDivElement, Props>(
  ({ id, className, size = 'medium', tag: Tag = 'h2', children }, ref) => (
    <Tag id={id} className={clsx('font-display uppercase', Size[size], className)} ref={ref}>
      {children}
    </Tag>
  )
);
